<template>
  <div class="day">
    <div class="form-group">

      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">{{ name }}</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">

        <div class="options-block">

          <a-switch :name="fieldName('open')" checkedChildren="Open" unCheckedChildren="Gesloten"
                    :checked="open"
                    @change="(x) => open = x"/>
          <input type="hidden" :name="fieldName('open')"
                 v-model.number="open"/>

          <span v-if="open">
                        <a-switch :name="fieldName('evening')" :checked="evening"
                                  @change="(x) => evening = x"/>
                        <input type="hidden" :name="fieldName('evening')"
                               v-model.number="evening"/>
                        Avond op afspraak
                    </span>

          <a-input v-if="exception" type="hidden" :name="fieldName('exception')"
                   value="true"></a-input>

        </div>

        <div v-if="open">
          <div v-for="(block, index) in blocks" :key="blockKey(block)">
            <a-time-picker :disabled="!open"
                           :default-value="moment(blockValue('from', index), 'HH:mm')" format="HH:mm"
                           :minute-step="15" @change="(t) => updateBlock(t, block,'from', index)"/>
            <a-input type="hidden" :name="fieldName('from', index)"
                     :value="blockValue('from', index)"></a-input>
            -
            <a-time-picker :inputName="fieldName('till', index)" :disabled="!open"
                           :default-value="moment(blockValue('till', index), 'HH:mm')" format="HH:mm"
                           :minute-step="15" @change="(t) => updateBlock(t, block,'till', index)"/>
            <a-input type="hidden" :name="fieldName('till', index)"
                     :value="blockValue('till', index)"></a-input>

            <a v-if="blocks.length === 1 && ( dayType ==='holiday' || dayType === 'exception' )"
               class="btn btn-primary"
               @click="removeDay(dayKey, dayType)">
              <i class="mdi mdi-delete-outline"></i>
            </a>

            <a v-if="blocks.length > 1" class="btn btn-primary" @click="removeBlock(index)">
              <i class="mdi mdi-delete-outline"></i>
            </a>

            <span v-if="index == blocks.length -1">
                            <a class="btn btn-primary" @click="addBlock">
                                <i class="mdi mdi-plus"></i>
                            </a>
                        </span>
          </div>
        </div>


      </div>
    </div>
  </div>


</template>

<script>

import moment from "moment";

export default {
  name: "OfficeHourDay",

  props: {
    name: {
      type: String,
      default: "Maandag"
    },
    horizontal: {
      type: Boolean,
      default: true
    },
    defaultFrom: {
      type: String,
      default: '08:00'
    },
    defaultTill: {
      type: String,
      default: '18:00'
    },
    block: {
      type: Object
    },
    value: {
      type: String
    },
    exception: {
      type: Boolean,
      default: false
    },
    days: {
      type: Array,
      required: false,
      default: () => ([])
    },
    dayType: {
      type: String,
      default: ''
    },
    dayKey: {
      type: Number,
      default: null
    },
  },
  data() {
    return {
      open: true,
      blocks: [],
      test: true,
      moment: moment,
      evening: false
    }
  },
  mounted() {
    this.days.forEach((day) => {
      this.blocks.push({from: day.from, till: day.till});
      this.open = day.open;
      this.evening = day.evening;
    });

    if (this.blocks.length === 0) {
      Vue.set(this.blocks, 0, {from: this.defaultFrom, till: this.defaultTill});
    }
  },
  methods: {
    addBlock() {
      this.blocks.push(
          {from: this.defaultFrom, till: this.defaultTill}
      );
    },
    removeBlock(index) {
      this.blocks.splice(index, 1);
    },
    updateBlock(time, block, key, index) {
      block[key] = time.format('HH:mm');
      Vue.set(this.blocks, index, block);
    },
    blockValue(key, index) {
      return this.blocks[index][key];
    },
    blockKey(block) {
      return block.from + block.till;
    },
    fieldName(name, depth) {
      if (depth !== undefined) {
        return 'days[' + this.value + '][blocks][' + depth + '][' + name + ']';
      }

      return 'days[' + this.value + '][' + name + ']';
    },
    removeDay(dayKey, dayType) {
      if (dayType === 'holiday') {
        store.dispatch('office/removeHoliday', dayKey);
      } else if (dayType === 'exception') {
        store.dispatch('office/removeException', dayKey);
      }
    },
  }
}
</script>

<style scoped>

.day {
}

.day .options-block {
  height: 2.5em;
}
</style>